// components/LoggedOut.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Cog6ToothIcon } from '@heroicons/react/24/outline';

export default function LoggedOut() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => navigate('/'), 3000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div
      className="flex flex-col items-center justify-center min-h-screen text-center"
       style={{
          backgroundImage: 'url("/background.png")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
  
      <img src="/2.png" alt="Logo" className="w-24 h-24 mb-6 rounded-full bg-gray-900" />
      <Cog6ToothIcon className="h-10 w-10 text-gray-600 animate-spin mb-4" />
      <h1 className="text-xl font-semibold text-blue-800">Logging out...</h1>
      <p className="text-blue-500 mt-2">Redirecting you to login</p>
    </div>
  );
}
